import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Logo } from './Logo';
import { Linkedin, Facebook } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();

  const handleContactClick = (e) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/#contact');
    } else {
      const element = document.querySelector('#contact');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer
      data-testid="footer"
      className="bg-accent text-white py-12"
    >
      <div className="container-width">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center" data-testid="footer-logo-link">
              <Logo variant="white" />
            </Link>
          </div>

          {/* Social Media Links */}
          <div className="flex items-center gap-4">
            <a
              href="https://www.linkedin.com/company/digitivehealth"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary transition-colors"
              data-testid="footer-linkedin-link"
              aria-label="Follow us on LinkedIn"
            >
              <Linkedin className="w-5 h-5 text-white" />
            </a>
            <a
              href="https://www.facebook.com/people/Digitive-Health-Inc/61581203067403/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary transition-colors"
              data-testid="footer-facebook-link"
              aria-label="Follow us on Facebook"
            >
              <Facebook className="w-5 h-5 text-white" />
            </a>
          </div>

          {/* Contact Link */}
          <a
            href="/#contact"
            onClick={handleContactClick}
            className="text-sm text-white/70 hover:text-primary transition-colors"
            data-testid="footer-contact-link"
          >
            Contact Us
          </a>

          {/* Copyright */}
          <p className="text-sm text-white/70">
            © {currentYear} Digitive Health Inc. All Rights Reserved.
          </p>

          {/* Links */}
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <Link
              to="/cookie-policy"
              className="text-sm text-white/70 hover:text-primary transition-colors"
              data-testid="cookie-policy-link"
            >
              Cookie Policy
            </Link>
            <span className="text-white/30">|</span>
            <Link
              to="/privacy-policy"
              className="text-sm text-white/70 hover:text-primary transition-colors"
              data-testid="privacy-policy-link"
            >
              Privacy Policy
            </Link>
            <span className="text-white/30">|</span>
            <Link
              to="/terms-of-service"
              className="text-sm text-white/70 hover:text-primary transition-colors"
              data-testid="terms-of-service-link"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
